import React from "react";
import commonStyles from "../commonStyles.module.scss";

export const SidebarSectionDivider = () => (
    <hr className={commonStyles.sidebarSectionDivider} />
);
